// Moment
const moment = require('moment-timezone');

export const getUserTimezone = () => {
    const userTimezone = moment.tz.guess();
    return userTimezone;
}

export const convertDateTimeToUserTimezone = (dateTime, userTimezone, companyTimezone) => {
    // console.log('Company timezone', dateTime, companyTimezone);
    
    const cynoDateTime = moment.tz(dateTime, companyTimezone);
    const userDateTime = cynoDateTime.clone().tz(userTimezone);
    return userDateTime;
}

export const getTodaysDate = () => {
    const now = moment();
    const localMomentNow = now.clone().tz(moment.tz.guess())
    const userDate = localMomentNow.format('YYYY-MM-DD')
    
    return userDate;
}

export const getCompanyTimezone = (sbmClient) => {
    return sbmClient.getCompanyTimezoneOffset().timezone;
}

export const getLocalTimestampFromDateString = (day, month, year) => {
   return moment.tz(`${year}-${month}-${day}`, 'YYYY-MM-DD', getUserTimezone()).format('x');
}

export const convertUtcToUserTimezone = (utcTime) => {
    const currentTz = moment.tz.guess();
    const userLocalDateTime = moment.utc(utcTime, 'x').clone().tz(currentTz)
    return userLocalDateTime;
}


// WEBPACK FOOTER //
// ./src/js/utils/timezoneUtils.js